import Definitions from "../../http_request/Model/Definitions/Definitions";
import {toast} from "react-toastify";

export const getFilterProductLine = (setFilterProductLine, setLoading) => {
    Definitions.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (data) => {
            setFilterProductLine(data)
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: (data) => {
            setLoading(data);
        },
    }).FilterProductLine();
};
